module.exports = __webpack_public_path__ + "img/logo.aad21f8e.png";